import clsx from 'clsx'
import React, { Children, FC, PropsWithChildren } from 'react'

import { Slider, useSlider } from '@Components/Slider'
import { SliderArrowLeft, SliderArrowRight } from '@Components/Slider/SliderArrows/SliderArrows'

import styles from './ComplementaryProducts.module.scss'

export interface ComplementaryProductsProps {
  header: string
}

export const ComplementaryProducts: FC<PropsWithChildren<ComplementaryProductsProps>> = ({ children, header }) => {
  const { onSlide, sliderRef, sliderState } = useSlider()

  return (
    <>
      <div className={styles.complementaryProductsTitle}>
        <p draggable={false}>{header}</p>
        <SliderArrowLeft className={styles.arrowLeft} onClick={sliderRef.current?.prev} sliderState={sliderState} />
        <SliderArrowRight className={styles.arrowRight} onClick={sliderRef.current?.next} sliderState={sliderState} />
      </div>
      <div className={styles.complementaryProducts}>
        <Slider
          className={clsx(
            styles.slider,
            Children.count(children) <= 2 && styles.singleColumn,
            Children.count(children) > 2 && styles.grid,
          )}
          onSlide={onSlide}
          ref={sliderRef}
        >
          {children}
        </Slider>
        <input
          className={clsx(styles.range, (!sliderState || sliderState.rangeMax === sliderState.rangeMin) && styles.hidden)}
          max={sliderState?.rangeMax ?? 0}
          min={sliderState?.rangeMin ?? 0}
          onChange={() => null}
          type="range"
          value={sliderState?.rangeValue ?? 0}
        />
      </div>
    </>
  )
}

